module.exports = __webpack_public_path__ + "img/horizontal_4_3_8011.11d3fab7.png";